import React from "react";
import { House } from 'lucide-react'

export const menuItems = {

  // header menu items
  header: [
    {
      label: <House size={20} />,
      to: "/",
      dropdown: false,
    },
    {
      label: "About",
      to: "",
      dropdown: true,
      items: [
        { label: "Host & Committee", to: "/host-and-committee" },
        { label: "General Information", to: "/general-info" },
        { label: "Privacy Policy", to: "/privacy-policy" },
        { label: "Latest News", to: "/latest-news" },
        { label: "Promotional Toolkit", to: "/promotional-toolkit" },
        { label: "Contact Us", to: "/contact" },
      ],
    },
    {
      label: "Destination",
      to: "",
      dropdown: true,
      items: [
        { label: "Conference Venue", to: "/conference-venue" },
        { label: "Discover Hobart", to: "/discover-hobart" },
      ],
    },
    {
      label: "Registration",
      to: "",
      dropdown: true,
      items: [
        { label: "Registration", to: "/registration" },
        { label: "Accommodation", to: "/accommodation" },
      ],
    },
    {
      label: "Program",
      to: "",
      dropdown: true,
      items: [
        { label: "Program at a Glance", to: "/program" },
        { label: "Call for Abstracts", to: "/call-for-abstracts" },
      ],
    },
    {
      label: "Sponsorship",
      to: "",
      dropdown: true,
      items: [
        { label: "Sponsorship Information", to: "/sponsorship-info" },
        { label: "Sponsors & Exhibitors", to: "/sponsors-and-exhibitors" },
      ],
    },
  ],

  // footer menu items
  footer: [
    {
      label: "About",
      items: [
        { label: "Host & Committee", to: "/host-and-committee" },
        { label: "General Information", to: "/general-info" },
        { label: "Privacy Policy", to: "/privacy-policy" },
        { label: "Latest News", to: "/latest-news" },
        { label: "Promotional Toolkit", to: "/promotional-toolkit" },
        { label: "Contact Us", to: "/contact" },
      ],
    },
    {
      label: "Destination",
      items: [
        { label: "Conference Venue", to: "/conference-venue" },
        { label: "Discover Hobart", to: "/discover-hobart" },
      ],
    },
    {
      label: "Registration",
      to: "",
      dropdown: true,
      items: [
        { label: "Registration", to: "/registration" },
        { label: "Accommodation", to: "/accommodation" },
      ],
    },
    {
      label: "Program",
      items: [
        { label: "Program at a Glance", to: "/program" },
        { label: "Call for Abstracts", to: "/call-for-abstracts" },
      ],
    },
    {
      label: "Sponsorship",
      items: [
        { label: "Sponsorship Information", to: "/sponsorship-info" },
        { label: "Sponsors & Exhibitors", to: "/sponsors-and-exhibitors" },
      ],
    }
  ],

  // social menu items
  social: [
    {
      name: "facebook",
      url: "https://www.facebook.com/AusACPDM",
      screenReader: "Follow us on Facebook",
    },
    // {
    //   name: "linkedin",
    //   url: "#",
    //   screenReader: "Follow us on LinkedIn",
    // },
    // {
    //   name: "instagram",
    //   url: "#",
    //   screenReader: "Follow us on Instagram",
    // },
    {
      name: "twitter",
      url: "https://twitter.com/AusACPDM",
      screenReader: "Follow us on Twitter",
    },
  ]
};
